<template>
  <div id="IndexApp" class="p-0">
    <Spinner @onAccept="reload" />
    <Home v-if="moduleToShow == 1" v-bind:autos="autos" :userData="userData" />
    <Navigation v-on:setPage="handlePage" />
  </div>
</template>

<script>
import Navigation from "../../componentes/Navbar.vue";
import Home from "./Home.vue";
import Account from "./Account.vue";
import Autos from "./Autos.vue";
import { getBaseUrl } from "../../store/actions/ModuloActions";
import axios from "axios";
import Spinner from "../../componentes/Spinner";

export default {
  data: function () {
    return {
      moduleToShow: 1,
      token: null,
      userData: {},
      autos: [],
    };
  },
  components: { Navigation, Autos, Home, Account, Spinner },
  methods: {
    reload() {
      location.reload();
    },
    handlePage(page) {
      this.moduleToShow = page;
    },

    async getAutos() {
      const url = `${getBaseUrl()}danos/api/v1/autodiario/getautos/${
        this.userData.idusuarioapp
      }`;
      const prom = await axios.get(url, {
        headers: {
          XAPPID: "F827FE82207B214D85FB0C8856B1BCB411D4",
          Authorization: `Bearer ${this.$route.query.token}`,
        },
      });

      if (prom) {
        this.$store.state.autos = prom.data.data;
        this.autos = this.$store.state.autos.filter(
          (auto) => auto.DiasVigenciaPoliza > 0
        );
        return true
      }
    },
    async getHistorial() {
      const url = `${getBaseUrl()}danos/api/v1/autodiario/gethistorial/${
        this.userData.idusuarioapp
      }`;
      const prom = await axios.get(url, {
        headers: {
          XAPPID: "F827FE82207B214D85FB0C8856B1BCB411D4",
          Authorization: `Bearer ${this.$route.query.token}`,
        },
      });
      if (prom) {
        this.$store.state.historial = prom.data.data;
        return true;
      }
    },
  },

  async created() {
    this.$store.state.showSpinner = true;
    this.$store.state.spinnerMessage = "Buscando tus autos...";

    const payload = {
      metodo: "GETUSERDATA",
      data: {
        usuario: this.$route.query.id,
        tipobusqueda: "1",
        token: this.$route.query.token,
      },
    };
    try {
      const response = await this.$store.dispatch("metodoPost", payload);

      if (response) {
        this.userData = this.$store.getters.getRespuestaREST.usuario;
        this.$store.state.userData =
          this.$store.getters.getRespuestaREST.usuario;
        const autos = await this.getAutos();
        const historial = await this.getHistorial();

        if (autos && historial) {
          this.$store.state.showSpinner = false;
          this.$store.state.spinnerMessage = false;
        }
      }
    } catch (error) {
      this.$store.state.spinnerIcon = "error";
      this.$store.state.spinnerMessage = "Lo sentimos, tu sesión ha expirado";
    }
  },
};
</script>

<style scoped>
#IndexApp {
  min-height: 100vh;
}
</style>